var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurpleRingForm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 279,
    height: 359,
    viewBox: "0 0 279 359",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.04,
    cx: 99.5,
    cy: 179.5,
    r: 144,
    stroke: "#5C2684",
    strokeWidth: 71
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleRingForm);
export default __webpack_public_path__ + "static/media/purple-ring-form.57109ec34231d90e1d4d9aa2eabeb1d1.svg";
export { ForwardRef as ReactComponent };